import { Anchor, Box, Center, Stack, Text, Title } from "@mantine/core";
import { useEffect } from "react";

const Support: React.FC = () => {
    useEffect(() => {
        document.title = "Support - Guard Dog Real Estate Protection Service";
    }, []);
    return (
        <Stack>
            <Box>
                <Center mt={20}>
                    <Title c='pq-red' style={{ fontFamily: 'Elston, sans-serif', letterSpacing: '2px' }} order={1}>WE'RE HERE TO HELP</Title>
                </Center>
                <Center>
                    <Text c='pq-red' fw='600'>Seriously.</Text>
                </Center>
            </Box>
            <Text>
                When we say, “call us,” we mean it.
                <br />
                <br />
                Our friendly support staff is ready to assist you with anything you may need regarding your Guard Dog&trade; account, items you'd like to guard, or with any other questions you may have.
            </Text>
            <Title c='black' order={2}>CALL US AT <Anchor c='pq-red' style={{ fontSize: 'var(--mantine-h2-font-size)' }} td='none' href='tel:8882178999'>888-217-8999</Anchor></Title>
            <Title c='black' order={2}>MONDAY THROUGH FRIDAY 8AM - 5PM PST</Title>
            <Text>or email us at <Anchor c='pq-red' href='mailto:guarddogsupport@parcelquest.com'>guarddogsupport@parcelquest.com</Anchor></Text>
        </Stack>
    );
}

export default Support;